// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2zCXy","content":"Consent_content__j8G0F","footer":"Consent_footer__1DEIs"};